import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import { vec4, mat4 } from "_src/libs/gl-matrix";

import vertText from "_src/shaders/text/text.glslv";
import fragText from "_src/shaders/text/text.glslf";

export default class TextShader extends Shader {

  constructor(params = {}) {

    super(params);
    this.attachUniforms(params);

  }

  compile() {
    super.compile(vertText, fragText);
  }

  getTextBuffer() {

    const numColumns = this.uniforms["u_dim"].value[0];
    const numRows = this.uniforms["u_dim"].value[1];

    const textureBuffer = new Uint8Array(4 * numRows * numColumns);

    for (let i = 0; i < numRows; ++i) {
      for (let j = 0; j < numColumns; ++j) {

        const charCode = getCharacterCode(this.string[i][j]);

        textureBuffer[4 * (i * numRows + j) + 0] = 16 * (charCode % 16);
        textureBuffer[4 * (i * numRows + j) + 1] = 16 * Math.floor(charCode / 16);

      }
    }

    return textureBuffer;

  }

  updateObjectUniformValues(object) {
    mat4.copy(this.uniforms["u_model_matrix"].value, object.modelMatrix);
    vec4.copy(this.uniforms["u_diffuse"].value, object.properties.diffuseColor);
  }

  updateSceneUniformValues(scene) {
    const camera = scene.camera;
    mat4.copy(this.uniforms["u_view_proj_matrix"].value, camera.viewProjMat);
  }

  attachUniforms(params) {

    const modelMatrix = mat4.create();
    const diffuseColor = vec4.fromValues(0.8, 0.8, 0.8, 1.0);
    const viewProjectionMatrix = mat4.create();
    const outlineColor = params.outlineColor !== undefined ? vec4.clone(params.outlineColor) : vec4.fromValues(1.0, 1.0, 1.0, 1.0 );

    this.uniforms["u_model_matrix"]     = new Uniform(uniformType.MAT4, modelMatrix, uniformSource.OBJECT);
    this.uniforms["u_diffuse"]          = new Uniform(uniformType.FLOAT4V, diffuseColor, uniformSource.OBJECT);
    this.uniforms["u_outline"]          = new Uniform(uniformType.FLOAT4V, outlineColor);
    this.uniforms["u_view_proj_matrix"] = new Uniform(uniformType.MAT4, viewProjectionMatrix, uniformSource.SCENE);

    this.uniforms["tDiffuse"]           = new Uniform(uniformType.INT1, 0);

  }

  setOutlineOpacity(opacity) {
    this.uniforms["u_outline"].value[3] = opacity;
    this.dropID();
  }

}

function getCharacterCode(char) {
  return char.charCodeAt(0);
}
